// extracted by mini-css-extract-plugin
export var expandMenuIcon = "BurgerIcon-module--expand-menu-icon--2YMr7";